<!--  -->
<template>
  <div>
    <div class="cont_r_b11">
      <span style="font-family:Arial;"></span>
      <span style="font-size:large;">
        <span style="line-height:36px;">
          <b>
            <p>
              <b></b>
            </p>
            <p>
              <span style="font-family:SimSun;">Brass Ingot</span>
              <span style="font-family:Arial;">LS59/LS60</span>
            </p>
          </b>
        </span>
      </span>
      <p></p>
      <table
        border="0"
        cellspacing="0"
        cellpadding="0"
        width="100%"
        style="width:100.0%;border-collapse:collapse;"
        class="ke-zeroborder"
      >
        <tbody>
          <tr>
            <td width="33%" valign="top" style="border:solid windowtext 1.0pt;">
              <p align="center" style="text-align:center;">
                <span style="font-family:Arial;">Element</span>
              </p>
            </td>
            <td width="33%" valign="top" style="border:solid windowtext 1.0pt;">
              <p align="center" style="text-align:center;">
                <span style="font-family:Arial;">LS59 (%)</span>
              </p>
            </td>
            <td width="33%" valign="top" style="border:solid windowtext 1.0pt;">
              <p align="center" style="text-align:center;">
                <span style="font-family:Arial;">LS60 (%)</span>
              </p>
            </td>
          </tr>
          <tr>
            <td width="33%" valign="top" style="border:solid windowtext 1.0pt;">
              <p align="center" style="text-align:center;">
                <span style="font-family:Arial;">Cu</span>
              </p>
            </td>
            <td width="33%" valign="top" style="border:solid windowtext 1.0pt;">
              <p align="center" style="text-align:center;">
                <span style="font-family:Arial;">56-61</span>
              </p>
            </td>
            <td width="33%" valign="top" style="border:solid windowtext 1.0pt;">
              <p align="center" style="text-align:center;">
                <span style="font-family:Arial;">60 min</span>
              </p>
            </td>
          </tr>
          <tr>
            <td width="33%" valign="top" style="border:solid windowtext 1.0pt;">
              <p align="center" style="text-align:center;">
                <span style="font-family:Arial;">Sb</span>
              </p>
            </td>
            <td width="33%" valign="top" style="border:solid windowtext 1.0pt;">
              <p align="center" style="text-align:center;">
                <span style="font-family:Arial;">0.05max</span>
              </p>
            </td>
            <td width="33%" valign="top" style="border:solid windowtext 1.0pt;">
              <p align="center" style="text-align:center;">
                <span style="font-family:Arial;">0.1 max</span>
              </p>
            </td>
          </tr>
          <tr>
            <td width="33%" valign="top" style="border:solid windowtext 1.0pt;">
              <p align="center" style="text-align:center;">
                <span style="font-family:Arial;">Pb</span>
              </p>
            </td>
            <td width="33%" valign="top" style="border:solid windowtext 1.0pt;">
              <p align="center" style="text-align:center;">
                <span style="font-family:Arial;">0.8-1.9</span>
              </p>
            </td>
            <td width="33%" valign="top" style="border:solid windowtext 1.0pt;">
              <p align="center" style="text-align:center;">
                <span style="font-family:Arial;">2.0 max</span>
              </p>
            </td>
          </tr>
          <tr>
            <td width="33%" valign="top" style="border:solid windowtext 1.0pt;">
              <p align="center" style="text-align:center;">
                <span style="font-family:Arial;">Sn</span>
              </p>
            </td>
            <td width="33%" valign="top" style="border:solid windowtext 1.0pt;">
              <p align="center" style="text-align:center;">
                <span style="font-family:Arial;">0.5max</span>
              </p>
            </td>
            <td width="33%" valign="top" style="border:solid windowtext 1.0pt;">
              <p align="center" style="text-align:center;">
                <span style="font-family:Arial;">1.0 max</span>
              </p>
            </td>
          </tr>
          <tr>
            <td width="33%" valign="top" style="border:solid windowtext 1.0pt;">
              <p align="center" style="text-align:center;">
                <span style="font-family:Arial;">Fe</span>
              </p>
            </td>
            <td width="33%" valign="top" style="border:solid windowtext 1.0pt;">
              <p align="center" style="text-align:center;">
                <span style="font-family:Arial;">0.8max</span>
              </p>
            </td>
            <td width="33%" valign="top" style="border:solid windowtext 1.0pt;">
              <p align="center" style="text-align:center;">
                <span style="font-family:Arial;">0.7 max</span>
              </p>
            </td>
          </tr>
          <tr>
            <td width="33%" valign="top" style="border:solid windowtext 1.0pt;">
              <p align="center" style="text-align:center;">
                <span style="font-family:Arial;">Al</span>
              </p>
            </td>
            <td width="33%" valign="top" style="border:solid windowtext 1.0pt;">
              <p align="center" style="text-align:center;">
                <span style="font-family:Arial;">0.5max</span>
              </p>
            </td>
            <td width="33%" valign="top" style="border:solid windowtext 1.0pt;">
              <p align="center" style="text-align:center;">
                <span style="font-family:Arial;">0.3 max</span>
              </p>
            </td>
          </tr>
          <tr>
            <td width="33%" valign="top" style="border:solid windowtext 1.0pt;">
              <p align="center" style="text-align:center;">
                <span style="font-family:Arial;">Ni</span>
              </p>
            </td>
            <td width="33%" valign="top" style="border:solid windowtext 1.0pt;">
              <p align="center" style="text-align:center;">
                <span style="font-family:Arial;">1.0max</span>
              </p>
            </td>
            <td width="33%" valign="top" style="border:solid windowtext 1.0pt;">
              <p align="center" style="text-align:center;">
                <span style="font-family:Arial;">0.5 max</span>
              </p>
            </td>
          </tr>
          <tr>
            <td width="33%" valign="top" style="border:solid windowtext 1.0pt;">
              <p align="center" style="text-align:center;">
                <span style="font-family:Arial;">Si</span>
              </p>
            </td>
            <td width="33%" valign="top" style="border:solid windowtext 1.0pt;">
              <p align="center" style="text-align:center;">
                <span style="font-family:Arial;">0.3max</span>
              </p>
            </td>
            <td width="33%" valign="top" style="border:solid windowtext 1.0pt;">
              <p align="center" style="text-align:center;">
                <span style="font-family:Arial;">0.2 max</span>
              </p>
            </td>
          </tr>
          <tr>
            <td width="33%" valign="top" style="border:solid windowtext 1.0pt;">
              <p align="center" style="text-align:center;">
                <span style="font-family:Arial;">Mn</span>
              </p>
            </td>
            <td width="33%" valign="top" style="border:solid windowtext 1.0pt;">
              <p align="center" style="text-align:center;">
                <span style="font-family:Arial;">0.5max</span>
              </p>
            </td>
            <td width="33%" valign="top" style="border:solid windowtext 1.0pt;">
              <p align="center" style="text-align:center;">
                <span style="font-family:Arial;">0.2 max</span>
              </p>
            </td>
          </tr>
          <tr>
            <td width="33%" valign="top" style="border:solid windowtext 1.0pt;">
              <p align="center" style="text-align:center;">
                <span style="font-family:Arial;">Zn</span>
              </p>
            </td>
            <td width="33%" valign="top" style="border:solid windowtext 1.0pt;">
              <p align="center" style="text-align:center;">
                <span style="font-family:Arial;">Balance</span>
              </p>
            </td>
            <td width="33%" valign="top" style="border:solid windowtext 1.0pt;">
              <p align="center" style="text-align:center;">
                <span style="font-family:Arial;">Balance</span>
              </p>
            </td>
          </tr>
          <tr>
            <td width="33%" valign="top" style="border:solid windowtext 1.0pt;">
              <p align="center" style="text-align:center;">
                <span style="font-family:Arial;">Ttl impurity</span>
              </p>
            </td>
            <td width="33%" valign="top" style="border:solid windowtext 1.0pt;">
              <p align="center" style="text-align:center;">
                <span style="font-family:Arial;">2.0max</span>
              </p>
            </td>
            <td width="33%" valign="top" style="border:solid windowtext 1.0pt;">
              <p align="center" style="text-align:center;">
                <span style="font-family:Arial;">1,5 max</span>
              </p>
            </td>
          </tr>
        </tbody>
      </table>
      <p></p>
      <p>
        <span style="font-family:SimSun;font-size:18px;line-height:1.5;">
          <br>
        </span>
      </p>
      <p>
        <span style="font-size:18px;line-height:1.5;">
          <span style="font-family:SimSun;">
            <strong>Brass Ingot</strong>
          </span>
          <strong>&nbsp;
            <span style="font-family:Arial;">M70</span>
          </strong>
        </span>
      </p>
      <table
        border="0"
        cellspacing="0"
        cellpadding="0"
        width="100%"
        style="width:100.0%;border-collapse:collapse;"
        class="ke-zeroborder"
      >
        <tbody>
          <tr>
            <td width="100%" colspan="5" valign="top" style="border:solid windowtext 1.0pt;">
              <p align="center" style="text-align:center;">
                <span style="font-family:Arial;">M70 TYPICAL</span>
              </p>
            </td>
          </tr>
          <tr>
            <td width="15%" valign="top" style="border:solid windowtext 1.0pt;">
              <p align="center" style="text-align:center;">
                <span style="font-family:Arial;">No.</span>
              </p>
            </td>
            <td width="18%" valign="top" style="border:solid windowtext 1.0pt;">
              <p align="center" style="text-align:center;">
                <span style="font-family:Arial;">Fe</span>
              </p>
            </td>
            <td width="24%" valign="top" style="border:solid windowtext 1.0pt;">
              <p align="center" style="text-align:center;">
                <span style="font-family:Arial;">Cu</span>
              </p>
            </td>
            <td width="24%" valign="top" style="border:solid windowtext 1.0pt;">
              <p align="center" style="text-align:center;">
                <span style="font-family:Arial;">Zn</span>
              </p>
            </td>
            <td width="18%" valign="top" style="border:solid windowtext 1.0pt;">
              <p align="center" style="text-align:center;">
                <span style="font-family:Arial;">Pb</span>
              </p>
            </td>
          </tr>
          <tr>
            <td width="15%" valign="top" style="border:solid windowtext 1.0pt;">
              <p align="center" style="text-align:center;">
                <span style="font-family:Arial;">1</span>
              </p>
            </td>
            <td width="18%" valign="top" style="border:solid windowtext 1.0pt;">
              <p align="center" style="text-align:center;">
                <span style="font-family:Arial;">0.05</span>
              </p>
            </td>
            <td width="24%" valign="top" style="border:solid windowtext 1.0pt;">
              <p align="center" style="text-align:center;">
                <span style="font-family:Arial;">72.23</span>
              </p>
            </td>
            <td width="24%" valign="top" style="border:solid windowtext 1.0pt;">
              <p align="center" style="text-align:center;">
                <span style="font-family:Arial;">27.19</span>
              </p>
            </td>
            <td width="18%" valign="top" style="border:solid windowtext 1.0pt;">
              <p align="center" style="text-align:center;">
                <span style="font-family:Arial;">0.53</span>
              </p>
            </td>
          </tr>
          <tr>
            <td width="15%" valign="top" style="border:solid windowtext 1.0pt;">
              <p align="center" style="text-align:center;">
                <span style="font-family:Arial;">2</span>
              </p>
            </td>
            <td width="18%" valign="top" style="border:solid windowtext 1.0pt;">
              <p align="center" style="text-align:center;">
                <span style="font-family:Arial;">0.55</span>
              </p>
            </td>
            <td width="24%" valign="top" style="border:solid windowtext 1.0pt;">
              <p align="center" style="text-align:center;">
                <span style="font-family:Arial;">71.6</span>
              </p>
            </td>
            <td width="24%" valign="top" style="border:solid windowtext 1.0pt;">
              <p align="center" style="text-align:center;">
                <span style="font-family:Arial;">27.18</span>
              </p>
            </td>
            <td width="18%" valign="top" style="border:solid windowtext 1.0pt;">
              <p align="center" style="text-align:center;">
                <span style="font-family:Arial;">0.66</span>
              </p>
            </td>
          </tr>
          <tr>
            <td width="15%" valign="top" style="border:solid windowtext 1.0pt;">
              <p align="center" style="text-align:center;">
                <span style="font-family:Arial;">3</span>
              </p>
            </td>
            <td width="18%" valign="top" style="border:solid windowtext 1.0pt;">
              <p align="center" style="text-align:center;">
                <span style="font-family:Arial;">0.05</span>
              </p>
            </td>
            <td width="24%" valign="top" style="border:solid windowtext 1.0pt;">
              <p align="center" style="text-align:center;">
                <span style="font-family:Arial;">72.07</span>
              </p>
            </td>
            <td width="24%" valign="top" style="border:solid windowtext 1.0pt;">
              <p align="center" style="text-align:center;">
                <span style="font-family:Arial;">27.45</span>
              </p>
            </td>
            <td width="18%" valign="top" style="border:solid windowtext 1.0pt;">
              <p align="center" style="text-align:center;">
                <span style="font-family:Arial;">0.38</span>
              </p>
            </td>
          </tr>
          <tr>
            <td width="15%" valign="top" style="border:solid windowtext 1.0pt;">
              <p align="center" style="text-align:center;">
                <span style="font-family:Arial;">4</span>
              </p>
            </td>
            <td width="18%" valign="top" style="border:solid windowtext 1.0pt;">
              <p align="center" style="text-align:center;">
                <span style="font-family:Arial;">0.56</span>
              </p>
            </td>
            <td width="24%" valign="top" style="border:solid windowtext 1.0pt;">
              <p align="center" style="text-align:center;">
                <span style="font-family:Arial;">71.27</span>
              </p>
            </td>
            <td width="24%" valign="top" style="border:solid windowtext 1.0pt;">
              <p align="center" style="text-align:center;">
                <span style="font-family:Arial;">27.53</span>
              </p>
            </td>
            <td width="18%" valign="top" style="border:solid windowtext 1.0pt;">
              <p align="center" style="text-align:center;">
                <span style="font-family:Arial;">0.64</span>
              </p>
            </td>
          </tr>
          <tr>
            <td width="15%" valign="top" style="border:solid windowtext 1.0pt;">
              <p align="center" style="text-align:center;">
                <span style="font-family:Arial;">5</span>
              </p>
            </td>
            <td width="18%" valign="top" style="border:solid windowtext 1.0pt;">
              <p align="center" style="text-align:center;">
                <span style="font-family:Arial;">0.51</span>
              </p>
            </td>
            <td width="24%" valign="top" style="border:solid windowtext 1.0pt;">
              <p align="center" style="text-align:center;">
                <span style="font-family:Arial;">71.77</span>
              </p>
            </td>
            <td width="24%" valign="top" style="border:solid windowtext 1.0pt;">
              <p align="center" style="text-align:center;">
                <span style="font-family:Arial;">27.08</span>
              </p>
            </td>
            <td width="18%" valign="top" style="border:solid windowtext 1.0pt;">
              <p align="center" style="text-align:center;">
                <span style="font-family:Arial;">0.64</span>
              </p>
            </td>
          </tr>
          <tr>
            <td width="15%" valign="top" style="border:solid windowtext 1.0pt;">
              <p align="center" style="text-align:center;">
                <span style="font-family:Arial;">6</span>
              </p>
            </td>
            <td width="18%" valign="top" style="border:solid windowtext 1.0pt;">
              <p align="center" style="text-align:center;">
                <span style="font-family:Arial;">0.52</span>
              </p>
            </td>
            <td width="24%" valign="top" style="border:solid windowtext 1.0pt;">
              <p align="center" style="text-align:center;">
                <span style="font-family:Arial;">71.71</span>
              </p>
            </td>
            <td width="24%" valign="top" style="border:solid windowtext 1.0pt;">
              <p align="center" style="text-align:center;">
                <span style="font-family:Arial;">27.31</span>
              </p>
            </td>
            <td width="18%" valign="top" style="border:solid windowtext 1.0pt;">
              <p align="center" style="text-align:center;">
                <span style="font-family:Arial;">0.46</span>
              </p>
            </td>
          </tr>
          <tr>
            <td width="15%" valign="top" style="border:solid windowtext 1.0pt;">
              <p align="center" style="text-align:center;">
                <span style="font-family:Arial;">7</span>
              </p>
            </td>
            <td width="18%" valign="top" style="border:solid windowtext 1.0pt;">
              <p align="center" style="text-align:center;">
                <span style="font-family:Arial;">0.43</span>
              </p>
            </td>
            <td width="24%" valign="top" style="border:solid windowtext 1.0pt;">
              <p align="center" style="text-align:center;">
                <span style="font-family:Arial;">71.75</span>
              </p>
            </td>
            <td width="24%" valign="top" style="border:solid windowtext 1.0pt;">
              <p align="center" style="text-align:center;">
                <span style="font-family:Arial;">27.2</span>
              </p>
            </td>
            <td width="18%" valign="top" style="border:solid windowtext 1.0pt;">
              <p align="center" style="text-align:center;">
                <span style="font-family:Arial;">0.62</span>
              </p>
            </td>
          </tr>
          <tr>
            <td width="15%" valign="top" style="border:solid windowtext 1.0pt;">
              <p align="center" style="text-align:center;">
                <span style="font-family:Arial;">8</span>
              </p>
            </td>
            <td width="18%" valign="top" style="border:solid windowtext 1.0pt;">
              <p align="center" style="text-align:center;">
                <span style="font-family:Arial;">0.5</span>
              </p>
            </td>
            <td width="24%" valign="top" style="border:solid windowtext 1.0pt;">
              <p align="center" style="text-align:center;">
                <span style="font-family:Arial;">71.37</span>
              </p>
            </td>
            <td width="24%" valign="top" style="border:solid windowtext 1.0pt;">
              <p align="center" style="text-align:center;">
                <span style="font-family:Arial;">27.52</span>
              </p>
            </td>
            <td width="18%" valign="top" style="border:solid windowtext 1.0pt;">
              <p align="center" style="text-align:center;">
                <span style="font-family:Arial;">0.6</span>
              </p>
            </td>
          </tr>
          <tr>
            <td width="15%" valign="top" style="border:solid windowtext 1.0pt;">
              <p align="center" style="text-align:center;">
                <span style="font-family:Arial;">9</span>
              </p>
            </td>
            <td width="18%" valign="top" style="border:solid windowtext 1.0pt;">
              <p align="center" style="text-align:center;">
                <span style="font-family:Arial;">0.49</span>
              </p>
            </td>
            <td width="24%" valign="top" style="border:solid windowtext 1.0pt;">
              <p align="center" style="text-align:center;">
                <span style="font-family:Arial;">71.25</span>
              </p>
            </td>
            <td width="24%" valign="top" style="border:solid windowtext 1.0pt;">
              <p align="center" style="text-align:center;">
                <span style="font-family:Arial;">27.64</span>
              </p>
            </td>
            <td width="18%" valign="top" style="border:solid windowtext 1.0pt;">
              <p align="center" style="text-align:center;">
                <span style="font-family:Arial;">0.62</span>
              </p>
            </td>
          </tr>
          <tr>
            <td width="15%" valign="top" style="border:solid windowtext 1.0pt;">
              <p align="center" style="text-align:center;">
                <span style="font-family:Arial;">10</span>
              </p>
            </td>
            <td width="18%" valign="top" style="border:solid windowtext 1.0pt;">
              <p align="center" style="text-align:center;">
                <span style="font-family:Arial;">0.55</span>
              </p>
            </td>
            <td width="24%" valign="top" style="border:solid windowtext 1.0pt;">
              <p align="center" style="text-align:center;">
                <span style="font-family:Arial;">71.3</span>
              </p>
            </td>
            <td width="24%" valign="top" style="border:solid windowtext 1.0pt;">
              <p align="center" style="text-align:center;">
                <span style="font-family:Arial;">27.55</span>
              </p>
            </td>
            <td width="18%" valign="top" style="border:solid windowtext 1.0pt;">
              <p align="center" style="text-align:center;">
                <span style="font-family:Arial;">0.59</span>
              </p>
            </td>
          </tr>
          <tr>
            <td width="15%" valign="top" style="border:solid windowtext 1.0pt;">
              <p align="center" style="text-align:center;">
                <span style="font-family:Arial;">11</span>
              </p>
            </td>
            <td width="18%" valign="top" style="border:solid windowtext 1.0pt;">
              <p align="center" style="text-align:center;">
                <span style="font-family:Arial;">0.54</span>
              </p>
            </td>
            <td width="24%" valign="top" style="border:solid windowtext 1.0pt;">
              <p align="center" style="text-align:center;">
                <span style="font-family:Arial;">71.5</span>
              </p>
            </td>
            <td width="24%" valign="top" style="border:solid windowtext 1.0pt;">
              <p align="center" style="text-align:center;">
                <span style="font-family:Arial;">27.6</span>
              </p>
            </td>
            <td width="18%" valign="top" style="border:solid windowtext 1.0pt;">
              <p align="center" style="text-align:center;">
                <span style="font-family:Arial;">0.37</span>
              </p>
            </td>
          </tr>
          <tr>
            <td width="15%" valign="top" style="border:solid windowtext 1.0pt;">
              <p align="center" style="text-align:center;">
                <span style="font-family:Arial;">12</span>
              </p>
            </td>
            <td width="18%" valign="top" style="border:solid windowtext 1.0pt;">
              <p align="center" style="text-align:center;">
                <span style="font-family:Arial;">0.57</span>
              </p>
            </td>
            <td width="24%" valign="top" style="border:solid windowtext 1.0pt;">
              <p align="center" style="text-align:center;">
                <span style="font-family:Arial;">71.17</span>
              </p>
            </td>
            <td width="24%" valign="top" style="border:solid windowtext 1.0pt;">
              <p align="center" style="text-align:center;">
                <span style="font-family:Arial;">27.7</span>
              </p>
            </td>
            <td width="18%" valign="top" style="border:solid windowtext 1.0pt;">
              <p align="center" style="text-align:center;">
                <span style="font-family:Arial;">0.56</span>
              </p>
            </td>
          </tr>
          <tr>
            <td width="15%" valign="top" style="border:solid windowtext 1.0pt;">
              <p align="center" style="text-align:center;">
                <span style="font-family:Arial;">13</span>
              </p>
            </td>
            <td width="18%" valign="top" style="border:solid windowtext 1.0pt;">
              <p align="center" style="text-align:center;">
                <span style="font-family:Arial;">0.77</span>
              </p>
            </td>
            <td width="24%" valign="top" style="border:solid windowtext 1.0pt;">
              <p align="center" style="text-align:center;">
                <span style="font-family:Arial;">71.03</span>
              </p>
            </td>
            <td width="24%" valign="top" style="border:solid windowtext 1.0pt;">
              <p align="center" style="text-align:center;">
                <span style="font-family:Arial;">27.39</span>
              </p>
            </td>
            <td width="18%" valign="top" style="border:solid windowtext 1.0pt;">
              <p align="center" style="text-align:center;">
                <span style="font-family:Arial;">0.53</span>
              </p>
            </td>
          </tr>
          <tr>
            <td width="15%" valign="top" style="border:solid windowtext 1.0pt;">
              <p align="center" style="text-align:center;">
                <span style="font-family:Arial;">14</span>
              </p>
            </td>
            <td width="18%" valign="top" style="border:solid windowtext 1.0pt;">
              <p align="center" style="text-align:center;">
                <span style="font-family:Arial;">0.48</span>
              </p>
            </td>
            <td width="24%" valign="top" style="border:solid windowtext 1.0pt;">
              <p align="center" style="text-align:center;">
                <span style="font-family:Arial;">71.56</span>
              </p>
            </td>
            <td width="24%" valign="top" style="border:solid windowtext 1.0pt;">
              <p align="center" style="text-align:center;">
                <span style="font-family:Arial;">27.36</span>
              </p>
            </td>
            <td width="18%" valign="top" style="border:solid windowtext 1.0pt;">
              <p align="center" style="text-align:center;">
                <span style="font-family:Arial;">0.61</span>
              </p>
            </td>
          </tr>
          <tr>
            <td width="15%" valign="top" style="border:solid windowtext 1.0pt;">
              <p align="center" style="text-align:center;">
                <span style="font-family:Arial;">15</span>
              </p>
            </td>
            <td width="18%" valign="top" style="border:solid windowtext 1.0pt;">
              <p align="center" style="text-align:center;">
                <span style="font-family:Arial;">0.69</span>
              </p>
            </td>
            <td width="24%" valign="top" style="border:solid windowtext 1.0pt;">
              <p align="center" style="text-align:center;">
                <span style="font-family:Arial;">71.73</span>
              </p>
            </td>
            <td width="24%" valign="top" style="border:solid windowtext 1.0pt;">
              <p align="center" style="text-align:center;">
                <span style="font-family:Arial;">26.96</span>
              </p>
            </td>
            <td width="18%" valign="top" style="border:solid windowtext 1.0pt;">
              <p align="center" style="text-align:center;">
                <span style="font-family:Arial;">0.64</span>
              </p>
            </td>
          </tr>
          <tr>
            <td width="15%" valign="top" style="border:solid windowtext 1.0pt;">
              <p align="center" style="text-align:center;">
                <span style="font-family:Arial;">16</span>
              </p>
            </td>
            <td width="18%" valign="top" style="border:solid windowtext 1.0pt;">
              <p align="center" style="text-align:center;">
                <span style="font-family:Arial;">0.73</span>
              </p>
            </td>
            <td width="24%" valign="top" style="border:solid windowtext 1.0pt;">
              <p align="center" style="text-align:center;">
                <span style="font-family:Arial;">70.71</span>
              </p>
            </td>
            <td width="24%" valign="top" style="border:solid windowtext 1.0pt;">
              <p align="center" style="text-align:center;">
                <span style="font-family:Arial;">27.91</span>
              </p>
            </td>
            <td width="18%" valign="top" style="border:solid windowtext 1.0pt;">
              <p align="center" style="text-align:center;">
                <span style="font-family:Arial;">0.64</span>
              </p>
            </td>
          </tr>
          <tr>
            <td width="15%" valign="top" style="border:solid windowtext 1.0pt;">
              <p align="center" style="text-align:center;">
                <span style="font-family:Arial;">17</span>
              </p>
            </td>
            <td width="18%" valign="top" style="border:solid windowtext 1.0pt;">
              <p align="center" style="text-align:center;">
                <span style="font-family:Arial;">0.63</span>
              </p>
            </td>
            <td width="24%" valign="top" style="border:solid windowtext 1.0pt;">
              <p align="center" style="text-align:center;">
                <span style="font-family:Arial;">71.34</span>
              </p>
            </td>
            <td width="24%" valign="top" style="border:solid windowtext 1.0pt;">
              <p align="center" style="text-align:center;">
                <span style="font-family:Arial;">27.55</span>
              </p>
            </td>
            <td width="18%" valign="top" style="border:solid windowtext 1.0pt;">
              <p align="center" style="text-align:center;">
                <span style="font-family:Arial;">0.48</span>
              </p>
            </td>
          </tr>
          <tr>
            <td width="15%" valign="top" style="border:solid windowtext 1.0pt;">
              <p align="center" style="text-align:center;">
                <span style="font-family:Arial;">18</span>
              </p>
            </td>
            <td width="18%" valign="top" style="border:solid windowtext 1.0pt;">
              <p align="center" style="text-align:center;">
                <span style="font-family:Arial;">0.57</span>
              </p>
            </td>
            <td width="24%" valign="top" style="border:solid windowtext 1.0pt;">
              <p align="center" style="text-align:center;">
                <span style="font-family:Arial;">70.9</span>
              </p>
            </td>
            <td width="24%" valign="top" style="border:solid windowtext 1.0pt;">
              <p align="center" style="text-align:center;">
                <span style="font-family:Arial;">28.08</span>
              </p>
            </td>
            <td width="18%" valign="top" style="border:solid windowtext 1.0pt;">
              <p align="center" style="text-align:center;">
                <span style="font-family:Arial;">0.45</span>
              </p>
            </td>
          </tr>
          <tr>
            <td width="15%" valign="top" style="border:solid windowtext 1.0pt;">
              <p align="center" style="text-align:center;">
                <span style="font-family:Arial;">19</span>
              </p>
            </td>
            <td width="18%" valign="top" style="border:solid windowtext 1.0pt;">
              <p align="center" style="text-align:center;">
                <span style="font-family:Arial;">0.65</span>
              </p>
            </td>
            <td width="24%" valign="top" style="border:solid windowtext 1.0pt;">
              <p align="center" style="text-align:center;">
                <span style="font-family:Arial;">70.52</span>
              </p>
            </td>
            <td width="24%" valign="top" style="border:solid windowtext 1.0pt;">
              <p align="center" style="text-align:center;">
                <span style="font-family:Arial;">28.15</span>
              </p>
            </td>
            <td width="18%" valign="top" style="border:solid windowtext 1.0pt;">
              <p align="center" style="text-align:center;">
                <span style="font-family:Arial;">0.68</span>
              </p>
            </td>
          </tr>
          <tr>
            <td width="15%" valign="top" style="border:solid windowtext 1.0pt;">
              <p align="center" style="text-align:center;">
                <span style="font-family:Arial;">20</span>
              </p>
            </td>
            <td width="18%" valign="top" style="border:solid windowtext 1.0pt;">
              <p align="center" style="text-align:center;">
                <span style="font-family:Arial;">0.47</span>
              </p>
            </td>
            <td width="24%" valign="top" style="border:solid windowtext 1.0pt;">
              <p align="center" style="text-align:center;">
                <span style="font-family:Arial;">71.45</span>
              </p>
            </td>
            <td width="24%" valign="top" style="border:solid windowtext 1.0pt;">
              <p align="center" style="text-align:center;">
                <span style="font-family:Arial;">27.87</span>
              </p>
            </td>
            <td width="18%" valign="top" style="border:solid windowtext 1.0pt;">
              <p align="center" style="text-align:center;">
                <span style="font-family:Arial;">0.54</span>
              </p>
            </td>
          </tr>
          <tr>
            <td width="15%" valign="top" style="border:solid windowtext 1.0pt;">
              <p align="center" style="text-align:center;">
                <span style="font-family:Arial;">21</span>
              </p>
            </td>
            <td width="18%" valign="top" style="border:solid windowtext 1.0pt;">
              <p align="center" style="text-align:center;">
                <span style="font-family:Arial;">0.54</span>
              </p>
            </td>
            <td width="24%" valign="top" style="border:solid windowtext 1.0pt;">
              <p align="center" style="text-align:center;">
                <span style="font-family:Arial;">70.82</span>
              </p>
            </td>
            <td width="24%" valign="top" style="border:solid windowtext 1.0pt;">
              <p align="center" style="text-align:center;">
                <span style="font-family:Arial;">28.04</span>
              </p>
            </td>
            <td width="18%" valign="top" style="border:solid windowtext 1.0pt;">
              <p align="center" style="text-align:center;">
                <span style="font-family:Arial;">0.61</span>
              </p>
            </td>
          </tr>
          <tr>
            <td width="15%" valign="top" style="border:solid windowtext 1.0pt;">
              <p align="center" style="text-align:center;">
                <span style="font-family:Arial;">22</span>
              </p>
            </td>
            <td width="18%" valign="top" style="border:solid windowtext 1.0pt;">
              <p align="center" style="text-align:center;">
                <span style="font-family:Arial;">0.41</span>
              </p>
            </td>
            <td width="24%" valign="top" style="border:solid windowtext 1.0pt;">
              <p align="center" style="text-align:center;">
                <span style="font-family:Arial;">71.16</span>
              </p>
            </td>
            <td width="24%" valign="top" style="border:solid windowtext 1.0pt;">
              <p align="center" style="text-align:center;">
                <span style="font-family:Arial;">27.99</span>
              </p>
            </td>
            <td width="18%" valign="top" style="border:solid windowtext 1.0pt;">
              <p align="center" style="text-align:center;">
                <span style="font-family:Arial;">0.44</span>
              </p>
            </td>
          </tr>
          <tr>
            <td width="15%" valign="top" style="border:solid windowtext 1.0pt;">
              <p align="center" style="text-align:center;">
                <span style="font-family:Arial;">23</span>
              </p>
            </td>
            <td width="18%" valign="top" style="border:solid windowtext 1.0pt;">
              <p align="center" style="text-align:center;">
                <span style="font-family:Arial;">0.54</span>
              </p>
            </td>
            <td width="24%" valign="top" style="border:solid windowtext 1.0pt;">
              <p align="center" style="text-align:center;">
                <span style="font-family:Arial;">70.63</span>
              </p>
            </td>
            <td width="24%" valign="top" style="border:solid windowtext 1.0pt;">
              <p align="center" style="text-align:center;">
                <span style="font-family:Arial;">28.4</span>
              </p>
            </td>
            <td width="18%" valign="top" style="border:solid windowtext 1.0pt;">
              <p align="center" style="text-align:center;">
                <span style="font-family:Arial;">0.44</span>
              </p>
            </td>
          </tr>
          <tr>
            <td width="15%" valign="top" style="border:solid windowtext 1.0pt;">
              <p align="center" style="text-align:center;">
                <span style="font-family:Arial;">24</span>
              </p>
            </td>
            <td width="18%" valign="top" style="border:solid windowtext 1.0pt;">
              <p align="center" style="text-align:center;">
                <span style="font-family:Arial;">0.57</span>
              </p>
            </td>
            <td width="24%" valign="top" style="border:solid windowtext 1.0pt;">
              <p align="center" style="text-align:center;">
                <span style="font-family:Arial;">71.06</span>
              </p>
            </td>
            <td width="24%" valign="top" style="border:solid windowtext 1.0pt;">
              <p align="center" style="text-align:center;">
                <span style="font-family:Arial;">27.9</span>
              </p>
            </td>
            <td width="18%" valign="top" style="border:solid windowtext 1.0pt;">
              <p align="center" style="text-align:center;">
                <span style="font-family:Arial;">0.47</span>
              </p>
            </td>
          </tr>
          <tr>
            <td width="15%" valign="top" style="border:solid windowtext 1.0pt;">
              <p align="center" style="text-align:center;">
                <span style="font-family:Arial;">25</span>
              </p>
            </td>
            <td width="18%" valign="top" style="border:solid windowtext 1.0pt;">
              <p align="center" style="text-align:center;">
                <span style="font-family:Arial;">0.44</span>
              </p>
            </td>
            <td width="24%" valign="top" style="border:solid windowtext 1.0pt;">
              <p align="center" style="text-align:center;">
                <span style="font-family:Arial;">71.02</span>
              </p>
            </td>
            <td width="24%" valign="top" style="border:solid windowtext 1.0pt;">
              <p align="center" style="text-align:center;">
                <span style="font-family:Arial;">27.96</span>
              </p>
            </td>
            <td width="18%" valign="top" style="border:solid windowtext 1.0pt;">
              <p align="center" style="text-align:center;">
                <span style="font-family:Arial;">0.58</span>
              </p>
            </td>
          </tr>
        </tbody>
      </table>
      <p style="display:inline !important;">
        <br>
      </p>
      <p style="display:inline !important;">
        <strong>
          <span style="font-family:SimSun;font-size:18px;">Bronze Ingot</span>
        </strong>
        <strong>
          <span style="font-size:18px;font-family:Arial;">BrO312</span>
        </strong>
      </p>
      <table
        border="0"
        cellspacing="0"
        cellpadding="0"
        width="100%"
        style="width:100.0%;border-collapse:collapse;"
        class="ke-zeroborder"
      >
        <tbody>
          <tr>
            <td width="41%" valign="top" style="border:solid windowtext 1.0pt;">
              <p align="center" style="text-align:center;">
                <span style="font-family:Arial;">Sn</span>
              </p>
            </td>
            <td width="58%" valign="top" style="border:solid windowtext 1.0pt;">
              <p align="center" style="text-align:center;">
                <span style="font-family:Arial;">2.0-3.5%</span>
              </p>
            </td>
          </tr>
          <tr>
            <td width="41%" valign="top" style="border:solid windowtext 1.0pt;">
              <p align="center" style="text-align:center;">
                <span style="font-family:Arial;">Zn</span>
              </p>
            </td>
            <td width="58%" valign="top" style="border:solid windowtext 1.0pt;">
              <p align="center" style="text-align:center;">
                <span style="font-family:Arial;">8.0-13.0%</span>
              </p>
            </td>
          </tr>
          <tr>
            <td width="41%" valign="top" style="border:solid windowtext 1.0pt;">
              <p align="center" style="text-align:center;">
                <span style="font-family:Arial;">Pb</span>
              </p>
            </td>
            <td width="58%" valign="top" style="border:solid windowtext 1.0pt;">
              <p align="center" style="text-align:center;">
                <span style="font-family:Arial;">3.0-6.0%</span>
              </p>
            </td>
          </tr>
          <tr>
            <td width="41%" valign="top" style="border:solid windowtext 1.0pt;">
              <p align="center" style="text-align:center;">
                <span style="font-family:Arial;">Sb</span>
              </p>
            </td>
            <td width="58%" valign="top" style="border:solid windowtext 1.0pt;">
              <p align="center" style="text-align:center;">
                <span style="font-family:Arial;">0.5%&nbsp;&nbsp;max</span>
              </p>
            </td>
          </tr>
          <tr>
            <td width="41%" valign="top" style="border:solid windowtext 1.0pt;">
              <p align="center" style="text-align:center;">
                <span style="font-family:Arial;">Fe</span>
              </p>
            </td>
            <td width="58%" valign="top" style="border:solid windowtext 1.0pt;">
              <p align="center" style="text-align:center;">
                <span style="font-family:Arial;">0.4%&nbsp;&nbsp;max</span>
              </p>
            </td>
          </tr>
          <tr>
            <td width="41%" valign="top" style="border:solid windowtext 1.0pt;">
              <p align="center" style="text-align:center;">
                <span style="font-family:Arial;">Al</span>
              </p>
            </td>
            <td width="58%" valign="top" style="border:solid windowtext 1.0pt;">
              <p align="center" style="text-align:center;">
                <span style="font-family:Arial;">0.02% max</span>
              </p>
            </td>
          </tr>
          <tr>
            <td width="41%" valign="top" style="border:solid windowtext 1.0pt;">
              <p align="center" style="text-align:center;">
                <span style="font-family:Arial;">Ni</span>
              </p>
            </td>
            <td width="58%" valign="top" style="border:solid windowtext 1.0pt;">
              <p align="center" style="text-align:center;">
                <span style="font-family:Arial;">1.0%&nbsp;&nbsp;max</span>
              </p>
            </td>
          </tr>
          <tr>
            <td width="41%" valign="top" style="border:solid windowtext 1.0pt;">
              <p align="center" style="text-align:center;">
                <span style="font-family:Arial;">Si</span>
              </p>
            </td>
            <td width="58%" valign="top" style="border:solid windowtext 1.0pt;">
              <p align="center" style="text-align:center;">
                <span style="font-family:Arial;">0.02% max</span>
              </p>
            </td>
          </tr>
          <tr>
            <td width="41%" valign="top" style="border:solid windowtext 1.0pt;">
              <p align="center" style="text-align:center;">
                <span style="font-family:Arial;">Mg</span>
              </p>
            </td>
            <td width="58%" valign="top" style="border:solid windowtext 1.0pt;">
              <p align="center" style="text-align:center;">
                <span style="font-family:Arial;">0.02% max</span>
              </p>
            </td>
          </tr>
          <tr>
            <td width="41%" valign="top" style="border:solid windowtext 1.0pt;">
              <p align="center" style="text-align:center;">
                <span style="font-family:Arial;">P</span>
              </p>
            </td>
            <td width="58%" valign="top" style="border:solid windowtext 1.0pt;">
              <p align="center" style="text-align:center;">
                <span style="font-family:Arial;">0.02% max</span>
              </p>
            </td>
          </tr>
          <tr>
            <td width="41%" valign="top" style="border:solid windowtext 1.0pt;">
              <p align="center" style="text-align:center;">
                <span style="font-family:Arial;">S</span>
              </p>
            </td>
            <td width="58%" valign="top" style="border:solid windowtext 1.0pt;">
              <p align="center" style="text-align:center;">
                <span style="font-family:Arial;">0.05% max</span>
              </p>
            </td>
          </tr>
          <tr>
            <td width="41%" valign="top" style="border:solid windowtext 1.0pt;">
              <p align="center" style="text-align:center;">
                <span style="font-family:Arial;">As</span>
              </p>
            </td>
            <td width="58%" valign="top" style="border:solid windowtext 1.0pt;">
              <p align="center" style="text-align:center;">
                <span style="font-family:Arial;">0.15% max</span>
              </p>
            </td>
          </tr>
          <tr>
            <td width="41%" valign="top" style="border:solid windowtext 1.0pt;">
              <p align="center" style="text-align:center;">
                <span style="font-family:Arial;">Cu</span>
              </p>
            </td>
            <td width="58%" valign="top" style="border:solid windowtext 1.0pt;">
              <p align="center" style="text-align:center;">
                <span style="font-family:Arial;">77.0%&nbsp;&nbsp;min</span>
              </p>
            </td>
          </tr>
        </tbody>
      </table>
      <p>
        <br>
      </p>
      <p>
        <strong>
          <span style="font-family:SimSun;font-size:18px;">Copper Ingot</span>
        </strong>
      </p>
      <p>
        <span style="font-family:Arial;">M98: Copper 98% min</span>
      </p>
      <p>
        <span style="font-family:Arial;">M99: Copper 99% min</span>
      </p>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },

  components: {},

  methods: {}
};
</script>
<style lang='stylus' rel='stylesheet/stylus'>
</style>


// WEBPACK FOOTER //
// src/components/en/product/ysjs.vue